import { useDispatch } from 'react-redux'
import { t } from 'ttag'
import { Link, useParams } from 'react-router-dom'

import { useTitleChange } from '../../util/hooks'
import WaitFor from '../../components/WaitFor'
import { requestEducatorGrant } from '../../actions/educatorAccountRequestActions'

const EducatorAccountRegistrationAcceptance = () => {
  const dispatch = useDispatch()

  useTitleChange(t`Congratulations, you've been upgraded!`)

  const { confirmationCode } = useParams()

  return (
    <WaitFor
      action={() => dispatch(requestEducatorGrant(confirmationCode))}
      throwOnError={false}>
      <div className="container">
        <div className="col-sm-3">
          <img
            alt="Navigator helping several explorers"
            aria-hidden={true}
            src="/images/www/new/pricing/HeaderGraphic-EducatorAccount.svg"
            className="img-responsive"
          />
        </div>
        <div className="col-sm-9">
          <p>{t`With your free navigator account, you will now be able to:`}</p>
          <ul className="free-educator-account-list">
            <li className="free-educator-manage">{t`Manage up to ${dynamicValues.defaultManageeLimit} explorers`}</li>
            <li className="free-educator-lesson">{t`Build and assign basic lesson plans`}</li>
            <li className="free-educator-messages">{t`Send messages`}</li>
            <li className="free-educator-reports">{t`Run basic reports to monitor each explorer's progress`}</li>
          </ul>
          <p>
            {t`When you visit the site, you will now have access to the management bar at the top of the screen.
                In it, you will find quick links to the functionality described above.`}
          </p>
          <p>{t`If you need help, be sure to check out our professional development sequence available in your CareerHub.`}</p>
          <p>
            <Link to="/" className="btn btn-success">{t`Get Started Now!`}</Link>
          </p>
        </div>
      </div>
    </WaitFor>
  )
}

export default EducatorAccountRegistrationAcceptance
